const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '')

const basePath = import.meta.env.VITE_APP_BASE_PATH || '/'

export const environment = {
  apiBaseUrl: trimTrailingSlash(import.meta.env.VITE_API_BASE_URL || ''),
  appBasePath: basePath.endsWith('/') ? basePath : `${basePath}/`,
  appVersion: import.meta.env.VITE_APP_VERSION || 'local',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  cognitoDomain: trimTrailingSlash((import.meta.env.VITE_COGNITO_DOMAIN || '').replace(/^https?:\/\//, '')),
  cognitoLogoutUri: import.meta.env.VITE_COGNITO_LOGOUT_URI || `${window.location.origin}${basePath}`,
  cognitoRedirectUri:
    import.meta.env.VITE_COGNITO_REDIRECT_URI || `${window.location.origin}${basePath}auth/callback`,
  cognitoScopes: import.meta.env.VITE_COGNITO_SCOPES || 'openid email profile',
  demoMode: import.meta.env.VITE_ENABLE_DEMO_MODE === 'true',
  idleTimeoutSeconds: Math.max(60, Number(import.meta.env.VITE_IDLE_TIMEOUT_SECONDS || 900))
}

export const cognitoConfigured = Boolean(environment.cognitoDomain && environment.cognitoClientId)

export const cognitoUrl = (path: string) => `https://${environment.cognitoDomain}${path}`
